import { render, staticRenderFns } from "./PhaseInput.vue?vue&type=template&id=71c55c5c&scoped=true&"
import script from "./PhaseInput.vue?vue&type=script&lang=ts&"
export * from "./PhaseInput.vue?vue&type=script&lang=ts&"
import style0 from "./PhaseInput.vue?vue&type=style&index=0&id=71c55c5c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c55c5c",
  null
  
)

export default component.exports